import { Injectable, signal } from '@angular/core';

/**
 * Scoped to MeasurementPage (provided at the component level, not root).
 * Lets any measurement-detail child — whether statically templated
 * (awaiting-start, never-started) or dynamically loaded via
 * `NgComponentOutlet` (the per-type started components, which can't bind
 * `(output)` events) — signal that the measurement's `started`/`active`
 * state may have changed, so the page can re-fetch and re-evaluate which
 * view to render.
 */
@Injectable()
export class MeasurementRefreshService {
  private readonly version = signal(0);

  readonly changed = this.version.asReadonly();

  trigger(): void {
    this.version.update((n) => n + 1);
  }
}
